import { render, staticRenderFns } from "./Thermostats.vue?vue&type=template&id=36f1dda7&"
import script from "./Thermostats.vue?vue&type=script&lang=js&"
export * from "./Thermostats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports